module.exports = __webpack_public_path__ + "static/media/active-mic-icon.121b7d3e.svg";